module.exports = __webpack_public_path__ + "static/media/aw-whistledog-2024-dt-fr.a58f1eb1.jpg";